/**
 * Which caption action, if any, should render a spinner.
 *
 * Extracted from PostBody so the "only the clicked chip spins" rule is
 * testable without mounting a 3,900-line component behind four providers.
 */
export function captionChipIsSpinning(
  chipActionId: string,
  operatingAction: string | null,
): boolean {
  return operatingAction === chipActionId;
}

export function captionChipIsDisabled(operatingAction: string | null): boolean {
  return operatingAction !== null;
}
